import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import _get from 'lodash/get';
import React, { useState } from 'react';
import classes from './MembersFilter.module.css';
import TimesCircleIcon from 'assets/images/times-circle.svg';
import { getRgbFromColorName } from 'shared/utility';

const MembersFilter = (props) => {
  const [filterInput, setFilterInput] = useState('');

  const containerClasses = [classes.Container];
  if (props.show) containerClasses.push(classes.Open);

  const selectAll = () => {
    const memberIds = props.allMembers.map((member) => member.User.UserId);
    props.select(memberIds, 'memberIds', true);
  };

  const selectMember = (memberId) => {
    props.select([memberId], 'memberIds');
  };

  const membersSort = (selectedMemberIds) => (a, b) => {
    if (selectedMemberIds.includes(a.User.UserId) && selectedMemberIds.includes(b.User.UserId)) {
      if (a.FirstName < b.FirstName) {
        return -1;
      }
      if (a.FirstName > b.FirstName) {
        return 1;
      }
      return 0;
    }
    if (selectedMemberIds.includes(a.User.UserId) && !selectedMemberIds.includes(b.User.UserId)) {
      return -1;
    }
    if (!selectedMemberIds.includes(a.User.UserId) && selectedMemberIds.includes(b.User.UserId)) {
      return 1;
    }
    if (a.User.FirstName < b.User.FirstName) {
      return -1;
    }
    if (a.User.FirstName > b.User.FirstName) {
      return 1;
    }
    return 0;
  };

  const filteredSortedMembers = props.allMembers
    ? props.allMembers
        .filter((member) => member.User.FirstName.toUpperCase().includes(filterInput.toUpperCase()))
        .sort(membersSort(props.selectedMemberIds))
    : [];

  return (
    <div className={containerClasses.join(' ')}>
      <div className={classes.FilterContainer}>
        <input onChange={(e) => setFilterInput(e.target.value)} value={filterInput} className={classes.FilterField} placeholder="Select name(s)" />
        {filterInput.length > 0 ? (
          <img src={TimesCircleIcon} alt="delete-location" onClick={() => setFilterInput('')} className={classes.DeleteLocation} />
        ) : null}
      </div>
      <div className={classes.Members}>
        {filteredSortedMembers.map((member) => {
          const imageURL = _get(member, 'User.ThumbURL', _get(member, 'User.ThumbURL'));
          return (
            <div
              key={member.User.UserId}
              className={props.selectedMemberIds.includes(member.User.UserId) ? [classes.Member, classes.Selected].join(' ') : classes.Member}
              onClick={() => selectMember(member.User.UserId)}
            >
              <div className={classes.FilterSelected}>
                <FontAwesomeIcon icon="check" className={classes.CheckMark} />
              </div>
              {imageURL && imageURL.charAt(member.User.ThumbURL.length - 1) !== '/' ? (
                <img
                  src={imageURL}
                  alt={`${member.User.FirstName}-image`}
                  style={{ border: `2px solid ${getRgbFromColorName(member.User.Color)}` }}
                />
              ) : (
                <div className={classes.ImagePlaceholder} style={{ backgroundColor: getRgbFromColorName(member.User.Color) }} />
              )}
              <p className={classes.FirstName}>{member.User.FirstName}</p>
              <p className={classes.LastName}>{member.User.LastName}</p>
            </div>
          );
        })}
      </div>
      <div className={classes.Controls}>
        <div className={classes.SelectOptions}>
          <p onClick={selectAll}>Select All</p>
          <p onClick={props.clear}>Clear</p>
        </div>
        <p className={classes.Save} onClick={props.submit}>
          SAVE
        </p>
      </div>
    </div>
  );
};

export default MembersFilter;
